// @generated by protoc-gen-es v2.2.3
// @generated from file creativefabrica/content/v2/types.proto (package creativefabrica.content.v2, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file creativefabrica/content/v2/types.proto.
 */
export const file_creativefabrica_content_v2_types = /*@__PURE__*/
  fileDesc("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");

/**
 * Describes the message creativefabrica.content.v2.Category.
 * Use `create(CategorySchema)` to create a new message.
 */
export const CategorySchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v2_types, 0);

/**
 * Describes the message creativefabrica.content.v2.Product.
 * Use `create(ProductSchema)` to create a new message.
 */
export const ProductSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v2_types, 1);

/**
 * Describes the message creativefabrica.content.v2.Images.
 * Use `create(ImagesSchema)` to create a new message.
 */
export const ImagesSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v2_types, 2);

/**
 * Describes the message creativefabrica.content.v2.Image.
 * Use `create(ImageSchema)` to create a new message.
 */
export const ImageSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v2_types, 3);

/**
 * Describes the message creativefabrica.content.v2.Pagination.
 * Use `create(PaginationSchema)` to create a new message.
 */
export const PaginationSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v2_types, 4);

/**
 * Describes the enum creativefabrica.content.v2.Language.
 */
export const LanguageSchema = /*@__PURE__*/
  enumDesc(file_creativefabrica_content_v2_types, 0);

/**
 * @generated from enum creativefabrica.content.v2.Language
 */
export const Language = /*@__PURE__*/
  tsEnum(LanguageSchema);

